document.addEventListener('DOMContentLoaded', () => {

  const buttons = document.querySelectorAll('[data-column-video-toggle]');

  if (!buttons.length) return;

  /* ==========================================================================
     LOAD YOUTUBE API
  ========================================================================== */

  let youtubePlayers = [];

  function loadYouTubeAPI() {

    return new Promise(resolve => {

      if (window.YT && window.YT.Player) {
        resolve();
        return;
      }

      const existing = document.querySelector(
        'script[src="https://www.youtube.com/iframe_api"]'
      );

      if (!existing) {

        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';

        document.head.appendChild(tag);

      }

      /*
      --------------------------------------------------------------------------
      PRESERVE EXISTING CALLBACKS
      --------------------------------------------------------------------------
      */

      const previous = window.onYouTubeIframeAPIReady;

      window.onYouTubeIframeAPIReady = () => {

        if (typeof previous === 'function') {
          previous();
        }

        resolve();

      };

    });

  }

  /* ==========================================================================
     INIT PLAYERS
  ========================================================================== */

  function initPlayers() {

    youtubePlayers = [];

    document.querySelectorAll('.column-tile__iframe').forEach(iframe => {

      /*
      --------------------------------------------------------------------------
      PREVENT DUPLICATE INIT
      --------------------------------------------------------------------------
      */

      if (iframe.dataset.columnYtInitialized === 'true') {
        return;
      }

      iframe.dataset.columnYtInitialized = 'true';

      /*
      --------------------------------------------------------------------------
      CREATE PLAYER
      --------------------------------------------------------------------------
      */

      const player = new YT.Player(iframe);

      youtubePlayers.push({
        iframe,
        player
      });

    });

  }

  /* ==========================================================================
     GET PLAYER
  ========================================================================== */

  function getPlayer(iframe) {

    if (!iframe) return null;

    const item = youtubePlayers.find(
      p => p.iframe === iframe
    );

    return item ? item.player : null;

  }

  /* ==========================================================================
     MUTE EVERYTHING
  ========================================================================== */

  function muteAll() {

    /*
    --------------------------------------------------------------------------
    SHOPIFY VIDEOS
    --------------------------------------------------------------------------
    */

    document.querySelectorAll('.column-tile__video').forEach(video => {

      video.muted = true;

    });

    /*
    --------------------------------------------------------------------------
    YOUTUBE VIDEOS
    --------------------------------------------------------------------------
    */

    youtubePlayers.forEach(item => {

      try {

        item.player.mute();

      } catch(e) {}

    });

    /*
    --------------------------------------------------------------------------
    BUTTON STATES
    --------------------------------------------------------------------------
    */

    buttons.forEach(button => {

      button.classList.remove('is-unmuted');
      button.classList.add('is-muted');

      button.setAttribute(
        'aria-label',
        'Unmute video'
      );

    });

  }

  /* ==========================================================================
     TOGGLE BUTTONS
  ========================================================================== */

  buttons.forEach(button => {

    button.addEventListener('click', (event) => {

      event.preventDefault();
      event.stopPropagation();

      const parent = button.closest(
        '.column-tile__video-parent'
      );

      if (!parent) return;

      const shopifyVideo = parent.querySelector(
        '.column-tile__video'
      );

      const youtubeIframe = parent.querySelector(
        '.column-tile__iframe'
      );

      const isCurrentlyMuted =
        button.classList.contains('is-muted');

      /*
      --------------------------------------------------------------------------
      MUTE ALL FIRST
      --------------------------------------------------------------------------
      */

      muteAll();

      /*
      --------------------------------------------------------------------------
      UNMUTE CURRENT
      --------------------------------------------------------------------------
      */

      if (isCurrentlyMuted) {

        /*
        ----------------------------------------------------------------------
        SHOPIFY VIDEO
        ----------------------------------------------------------------------
        */

        if (shopifyVideo) {

          shopifyVideo.muted = false;

          try {

            shopifyVideo.play();

          } catch(e) {}

        }

        /*
        ----------------------------------------------------------------------
        YOUTUBE VIDEO
        ----------------------------------------------------------------------
        */

        if (youtubeIframe) {

          const player = getPlayer(youtubeIframe);

          if (player) {

            try {

              /*
              ----------------------------------------------------------------
              FORCE PLAY
              ----------------------------------------------------------------
              */

              player.playVideo();

              /*
              ----------------------------------------------------------------
              UNMUTE
              ----------------------------------------------------------------
              */

              player.unMute();

              /*
              ----------------------------------------------------------------
              FORCE VOLUME
              ----------------------------------------------------------------
              */

              player.setVolume(100);

            } catch(e) {}

          }

        }

        /*
        ----------------------------------------------------------------------
        BUTTON STATE
        ----------------------------------------------------------------------
        */

        button.classList.remove('is-muted');
        button.classList.add('is-unmuted');

        button.setAttribute(
          'aria-label',
          'Mute video'
        );

      }

    });

  });

  /* ==========================================================================
     INIT
  ========================================================================== */

  loadYouTubeAPI().then(() => {

    initPlayers();

    muteAll();

  });

});